/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
import {CommonService} from "../service/common";
import {timeout} from "rxjs/operators";
declare var $:any;
@Component({
  templateUrl:'./memberNotifyEdit.html'
})

export class MemberNotifyEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location,
    private common:CommonService,
    private fileupload:FileUpload
  ){}

  private data:any={
    content:[]
  }

  private id:number = 0;
  public notifyStatusMore=[];
  public notifyTypeMore=[];


  private isCreate:boolean=false;

  ngOnInit(): void {
    this.getNotifyType();
    this.getNotifyStatus();
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });
    this.getData();
  }

  //获取推送类型
  private getNotifyType():void{
    this.HttpService.getData(API.notifyType).then(res=>{
      this.notifyTypeMore= res.data;
    })
  };
//获取推送状态
  private getNotifyStatus():void{
    this.HttpService.getData(API.notifyStatus).then(res=>{
      this.notifyStatusMore= res.data;
    })
  }

  private getData():void{
    this.HttpService.getData(API.notificationMessage+"/"+this.id).then(res=>{
      this.data = res.data;
    })
  }


}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/notify/memberNotifyEdit.component.ts